var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{staticClass:"linkTree left-tree"},[_c('el-tree',{ref:"searchTree",staticStyle:{"margin-bottom":"12px"},attrs:{"show-checkbox":"","props":_vm.controlCenterProps,"data":_vm.searchData,"node-key":"thirdDeviceId","default-expand-all":true,"render-content":_vm.renderContent},on:{"check":_vm.nodeCheck}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }